// extracted by mini-css-extract-plugin
export default {"container":"products_container__s+Goo","heading":"products_heading__unmWS"};